import axios from 'axios';
import EventPublisher from '../events/EventPublisher';
import AppEvent from '../events/AppEvent';
import Registry from '../../project/global/Registry';
import Repository from '../repository/Repository';
import Entity from '../domain/Entity';
import EntityId from '../domain/EntityId';

abstract class Api<T extends Entity<T>> {

	protected constructor (private repository: Repository<T>) {}

	protected static async publish (event: AppEvent) {
		await EventPublisher.getInstance().publish(event);
	}

	protected async deleteOne (url: string | Array<string | EntityId<any>>) {
		try {
			return await axios.delete(this.processUrl(url), {headers: this.getHeaders()});

		} catch (e) {
			if (e.response && e.response.data) {
				await Registry.getInstance().addErrorMessage(e.response.data.message);
			}

			throw e;
		}
	}

	protected async getList (url: string | Array<string | EntityId<any>>) {
		const result = await this.get(url);

		return this.repository.mapList(result.data.data);
	}

	protected async getOne (url: string | Array<string | EntityId<any>>) {
		const result = await this.get(url);

		return this.repository.mapOne(result.data.data);
	}

	protected async postOne (url: string | Array<string | EntityId<any>>, data: any = {}) {
		const result = await this.post(url, data);

		return this.repository.mapOne(result.data.data);
	}

	protected async post (url: string | Array<string | EntityId<any>>, data: any = {}) {
		try {
			return await axios.post(this.processUrl(url), data, { headers: this.getHeaders() });

		} catch (e) {
			if (e.response && e.response.data) {
				await Registry.getInstance().addErrorMessage(e.response.data.message);
			}

			throw e;
		}
	}

	private getHeaders () {
		const headers: any = {};

		headers.clientIdentifier = 'Website';

		const token = Registry.getInstance().authenticationTokenRepository.getToken();

		if (token !== undefined) {
			headers.Authorization = 'Bearer ' + token.getValue();
		}

		return headers;
	}

	private processUrl (url: string | Array<string | EntityId<any>>) {
		if (!Array.isArray(url)) {
			return url;
		}

		return url.map(value => value instanceof EntityId ? value.getValue() : value).join('');
	}

	private async get (url: string | Array<string | EntityId<any>>) {
		try {
			return await axios.get(this.processUrl(url), {headers: this.getHeaders()});

		} catch (e) {
			if (e.response && e.response.data) {
				await Registry.getInstance().addErrorMessage(e.response.data.message);
			}

			throw e;
		}
	}
}

export default Api;


// WEBPACK FOOTER //
// ./code/foundation/api/Api.ts